/* eslint-disable max-len */
export const TABLE_EXTRACT_PT_BR = {
	consolidated: {
		title: "Consolidado de Competência",
		totalTitle: "Total de lançamento na competência de {{period}}",
		tooltip: "O que é o resumo de competência?",
		tooltipDescription:
			"Operações agrupadas pela data em que a operação ou evento econômico realmente ocorreu.",
	},
	cashFlow: {
		title: "Movimentação do período",
		totalTitle: "Saldo final liquidado do período",
		tooltip: "O que é o resumo de movimentação?",
		tooltipDescription:
			"Operações de movimentação realizadas durante o período selecionado.",
	},
	tpv: {
		title: "Recebíveis do Período",
		totalTitle: "Total do Período",
		tooltip: "O que são Recebíveis do Período?",
		tooltipDescription:
			"Valor bruto dos TPVs agrupados do período consultado, representando os valores a receber das transações processadas.",
	},
	total: "Total",
	name: "Descrição",
	value: "Valor",
	grossValue: "Valor Bruto",
	netValue: "Valor Líquido",
	tax: "Taxa",
	base: "Base",
	feePercentage: "Taxa",
	from: "De",
	to: "a",
	group: "Agrupamento",
	excel: {
		title:
			"Relatório Consolidado por Período de Movimentação e Consolidado de Competência {{startDate}} a {{endDate}}",
		fileName:
			"relatorio-financeiro-consolidado_movimentacao_{{startDate}}_a_{{endDate}}.xlsx",
	},
	withdrawalsPeriod: "Movimentação do período",
	competenceConsolidated: "Consolidado de Competência",
	notLiquidatedTransactions: "Transações não liquidadas do período",
	anticipatedValue: "Valor Antecipado",
	obs: "Observação",
	seeTransactions: "Ver Transações",
	dateType: {
		competence: "Data de Competência",
		liquidation: "Data de Liquidação",
	},
	dateTypeLabel: "Filtrar por",
	competence: "Competência",
	liquidation: "Liquidação",
	apply: "Aplicar",
	totalEntries: "Total de Entradas",
	totalExits: "Total de Saídas",
	initialBalance: "Saldo Inicial",
};

export type TableExtractPtBr = typeof TABLE_EXTRACT_PT_BR;
